import { pageSizeKeys, settingKeys } from 'constants/configKeys';
import type { RootState } from 'store';
import { UserConfigs } from 'app/userPreferences/types';
import { createSelector } from 'reselect';
import { selectAuthUserPartnerAccesses } from 'app/auth/selectors';

export const selectUserConfigs = (state: RootState) => state.userPreferences.configs;

export const selectUserConfig = <T extends keyof UserConfigs>(state: RootState, key: T):UserConfigs[T] => state.userPreferences.configs[key];

export const selectUserConfigMenuCollapse = (state: RootState) => selectUserConfig(state, settingKeys.menuCollapse);

export const selectUserConfigTimeZone = (state: RootState) => selectUserConfig(state, settingKeys.timeZone);

export const selectUserConfigLanguageId = (state: RootState) => selectUserConfig(state, settingKeys.languageId);

export const selectUserConfigIsNightMode = (state: RootState) => selectUserConfig(state, settingKeys.isNightMode);

export const selectUserConfigPageSize = (state: RootState) => selectUserConfig(state, settingKeys.pageSize);

export const selectUserConfigPlayersPageSize = (state: RootState) => selectUserConfig(state, pageSizeKeys.playersPageSize);

export const selectUserConfigCampaignsPageSize = (state: RootState) => selectUserConfig(state, pageSizeKeys.campaignsPageSize);

export const selectUserConfigBrandSettingsExpand = (state: RootState) => selectUserConfig(state, settingKeys.brandSettingsExpand);

export const selectUserConfigBetAggregationsByPlayerCriteria = (state: RootState) => selectUserConfig(state, settingKeys.betAggregationsByPlayerCriteria);

export const selectUserConfigBetAggregationsByCurrencyCriteria = (state: RootState) => selectUserConfig(state, settingKeys.betAggregationsByCurrencyCriteria);

export const selectUserConfigPlayerMainInfoPosition = (state: RootState) => selectUserConfig(state, settingKeys.playerMainInfoPosition);

export const selectUserConfigPlayerPerformance = (state: RootState) => selectUserConfig(state, settingKeys.playerPerformance);

const selectCurrent = (state: RootState) => state.userPreferences.current;

export const selectCurrentBrandId = (state: RootState) => selectCurrent(state).brandId;

export const selectCurrentPartnerId = (state: RootState) => selectCurrent(state).partnerId;

export const selectCurrentPartner = createSelector(
  [selectAuthUserPartnerAccesses, selectCurrentPartnerId],
  (partners, id) => partners.find((partner) => partner.id === id),
);

export const selectCurrentConversionId = (state: RootState) => selectCurrent(state).conversionId;
